import React from "react";
import {
  Box,
  VStack,
  Text,
  Button,
  Badge,
  Flex,
  Tooltip,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

interface ProfileStatsProps {
  executiveId: number | string;
  projects: {
    count: string;
    names: string;
  };
  pendingActions: string;
  totalMeetings: string;
  activeClients: string;
  name: string;
  email : string;
}

export function ProfileStats({
  executiveId,
  projects,
  pendingActions,
  totalMeetings,
  activeClients,
  name,
  email
}: ProfileStatsProps) {
  const navigate = useNavigate();
  
  // Get first project from the list
  const firstProject = projects.names.split(",")[0].trim();

  const displayPosition = (() => {
    switch (email) {
      case "simmy7069@gmail.com":
        return "Jr Sales Executive";
      case "info@rahejagroup.co.in":
        return "VP Sales & Marketing";
      case "kusum03041996@gmail.com":
        return "Sales Executive";
      case "sachingoswami077@gmail.com":
        return "AGM Sales";
      default:
        return "Sales Executive";
    }
  })();
  
  // Generate mock email based on name
  const generateEmail = (name: string) => {
    const cleanName = email.replace(/\s+/g, '').toLowerCase();
    return `${cleanName}`;
  };

  const handleViewProfile = () => {
    // Pass name and email as query params
    const email = generateEmail(name);
    navigate(`/sales-executive/${executiveId}?name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}`);
  };

  return (
    <Box
      as="section"
      display="flex"
      flexDirection="column"
      flex="1"
      p={6}
      bg="white"
      position="relative"
      minWidth="0"
    >
      <Badge
        position="absolute"
        top={4}
        right={6}
        px={4}
        py={1.5}
        fontSize="xs"
        fontWeight="500"
        bg="#805AD5"
        color="white"
        borderRadius="md"
        textTransform="none"
      >
        {displayPosition}
      </Badge>
      
      <Box
        display="flex"
        flexDirection="column"
        flex="1"
        justifyContent="space-between"
        mt={16}
        width="100%"
      >
        <VStack spacing={3} align="flex-end" width="100%">
          <Flex justifyContent="flex-end" width="100%" alignItems="center">
            <Text fontSize="sm" color="gray.800" whiteSpace="nowrap" mr={2} flexShrink={0}>
              Projects:
            </Text>
            <Text fontSize="sm" color="gray.500" whiteSpace="nowrap" mr={1} flexShrink={0}>
              ({projects.count})
            </Text>
            <Tooltip 
              label={projects.names} 
              placement="bottom" 
              hasArrow
              bg="#805AD5" 
              color="white"
              borderRadius="md"
              fontSize="sm"
              fontWeight="medium"
              px={3}
              py={2}
            >
              <Text 
                fontSize="sm" 
                color="gray.500"
                textAlign="right"
                cursor="pointer"
                _hover={{ color: "#805AD5" }}
              >
                {firstProject}
            </Text>
            </Tooltip>
          </Flex>
          {/* <Flex justifyContent="flex-end" width="100%" alignItems="center">
            <Text fontSize="sm" color="gray.500" whiteSpace="nowrap" mr={2} flexShrink={0}>
              Pending Actions:
            </Text>
            <Text fontSize="sm" fontWeight="500" flexShrink={0}>
              {pendingActions}
            </Text>
          </Flex> */}
          <Flex justifyContent="flex-end" width="100%" alignItems="center">
            <Text fontSize="sm" color="gray.500" whiteSpace="nowrap" mr={2} flexShrink={0}>
              Total Meetings:
            </Text>
            <Text fontSize="sm" fontWeight="500" whiteSpace="nowrap" flexShrink={0}>
              {totalMeetings}
            </Text>
          </Flex>
          {/* <Flex justifyContent="flex-end" width="100%" alignItems="center">
            <Text fontSize="sm" color="gray.500" whiteSpace="nowrap" mr={2} flexShrink={0}>
              Active Clients:
            </Text>
            <Text fontSize="sm" fontWeight="500" whiteSpace="nowrap" flexShrink={0}>
              {activeClients}
            </Text>
          </Flex> */}
        </VStack>
        
        <Button
          alignSelf="flex-end"
          mt={4}
          bg="#1A202C"
          color="white"
          _hover={{ bg: "#2D3748" }}
          width="120px"
          height="auto"
          py={2}
          fontSize="xs"
          fontWeight="500"
          borderRadius="md"
          onClick={handleViewProfile}
        >
          View Profile
        </Button>
      </Box>
    </Box>
  );
} 